var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("cancelAccount.protocol"),
            visible: _vm.agreementDia,
            width: "40%",
            "custom-class": "agreementDia-cla"
          },
          on: {
            "update:visible": function($event) {
              _vm.agreementDia = $event
            }
          }
        },
        [
          _c("div", [
            _c("iframe", {
              attrs: {
                frameborder: "0",
                name: "agreementFrame",
                width: "100%",
                onload: "this.height=agreementFrame.document.body.scrollHeight",
                src: _vm.agreementSrc,
                scrolling: "no"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("common.notice"),
            visible: _vm.cancelAccountTipDia,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.cancelAccountTipDia = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("i", {
                staticClass: "el-icon-warning-outline",
                staticStyle: { "font-size": "60px", color: "#FF4D4D" }
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { "padding-left": "20px" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("cancelAccount.cancelTip")) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function($event) {
                      _vm.cancelAccountTipDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.not")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.showValidateDia }
                },
                [_vm._v(_vm._s(_vm.$t("common.yes")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "validataDia-cla",
            title: _vm.$t("common.notice"),
            visible: _vm.validateDia,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.validateDia = $event
            }
          }
        },
        [
          _c("div", { staticClass: "validate-row" }, [
            _c("div", { staticStyle: { width: "80px" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("cancelAccount.verificationType")) +
                  "：\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "200px" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.validateType === "email"
                      ? _vm.emailFormat(_vm.validateAccount)
                      : _vm.phoneFormat(_vm.validateAccount)
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.showChange
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.changeValidateType }
                      },
                      [_vm._v(_vm._s(_vm.$t("cancelAccount.changeType")))]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "validate-row" }, [
            _c("div", { staticStyle: { width: "80px" } }, [
              _vm._v(_vm._s(_vm.$t("cancelAccount.code")) + "：")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { width: "200px" } },
              [
                _c("el-input", {
                  attrs: { placeholder: _vm.$t("cancelAccount.inputCode") },
                  model: {
                    value: _vm.validateCode,
                    callback: function($$v) {
                      _vm.validateCode = $$v
                    },
                    expression: "validateCode"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.btnDisable, type: "primary" },
                    on: { click: _vm.getValidateCode }
                  },
                  [_vm._v(_vm._s(_vm.btnText))]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function($event) {
                      _vm.validateDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.not")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.validateCode === "", type: "danger" },
                  on: { click: _vm.submitValidateDia }
                },
                [_vm._v(_vm._s(_vm.$t("common.yes")))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("common.notice"),
            visible: _vm.cancleAccountDia,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.cancleAccountDia = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("i", {
                staticClass: "el-icon-warning-outline",
                staticStyle: { "font-size": "60px", color: "#FF4D4D" }
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { "padding-left": "20px" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("cancelAccount.exportTip")) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function($event) {
                      _vm.cancleAccountDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.not")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.submitCancelAccount }
                },
                [_vm._v(_vm._s(_vm.$t("cancelAccount.withdraw")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14844bc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14844bc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/personCenter/dialog/cancelAccount.vue
// module id = null
// module chunks = 